import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Note } from 'app/core/model/note';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm } from 'devextreme/ui/dialog';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { DealerNoteDialogComponent } from '../dealer-note-dialog/dealer-note-dialog.component';

@Component({
    selector: 'app-dealer-notes',
    templateUrl: './dealer-notes.component.html',
    styleUrls: ['./dealer-notes.component.scss'],
    standalone: false,
})
export class DealerNotesComponent implements OnInit {
    notes: any[] = [];
    dealers: any[] = [];
    ready = false;

    @Input() dealerId: string;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private modalService: BsModalService, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, public auth: AuthService) {}

    async ngOnInit() {
        this.dealers = await this.uow.getDealers(true);
        await this.getData();
        this.ready = true;
    }

    async getData() {
        let notes = await this.uow.getNotes('Dealer');

        if (this.dealerId) {
            notes = notes.filter((note) => note.primaryKey?.toString() === this.dealerId.toString());
        }

        notes.forEach((note: any) => {
            const dealer = this.dealers.find((d) => d.id.toString() === note.primaryKey);
            note.dealerName = dealer?.companyName;
        });
        this.notes = notes;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async edit(note?: Note) {
        const modalRef = this.modalService.show(DealerNoteDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                note: note ?? null,
                dealerId: this.dealerId,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    async delete(note: Note) {
        const confirmed = await confirm('Are you sure you want to delete this note?', this.appInfo.settings.company);
        if (!confirmed) return;

        note.deleted = new Date();
        await this.uow.commit([note]);
        await this.getData();
    }
}
